import React from "react";
import { Button, Spin } from "antd";
import isEmpty from "lodash/isEmpty";
import uniq from "lodash/uniq";
import isEqual from "lodash/isEqual";

import WeaAssociativeSearchMult from "../../base/wea-associative-search-mult";

import WeaNewScroll from "../../wea-new-scroll";
import WeaTools from "../../wea-tools";
import WeaDropMenu from "../../wea-drop-menu";
import WeaTree from "../../wea-tree";
import WeaDialog from "../../wea-dialog";
import WeaTab from "../../wea-tab";
import WeaLocaleProvider from "../../wea-locale-provider";

const getLabel = WeaLocaleProvider.getLabel;

import * as util from "./util";

const initialState = {
  checkedKeys: [],
  checkedDatas: [],
  expandedKeys: [],
  inputValue: "",
  loading: false
};

class main extends React.Component {
  static defaultProps = {
    tabs: [
      {
        name: getLabel("22243", "文档"),
        key: "1",
        dataParams: { sourcetype: "1" }
      },
      {
        name: getLabel("30045", "流程"),
        key: "2",
        dataParams: { sourcetype: "2" }
      },
      {
        name: getLabel("136", "客户"),
        key: "3",
        dataParams: { sourcetype: "3" }
      },
      {
        name: getLabel("101", "项目"),
        key: "4",
        dataParams: { sourcetype: "4" }
      }
    ],
    quickSearchName: "name"
  };
  constructor(props) {
    super(props);
    this.state = {
      selectedData: {}, // 搜索按钮选中的数据
      searchKeys: [], // 搜索按钮选择的keys
      inputValue: "",
      hiddenIds: "",
      checkedDatas: [],
      loading: true,
      loadAll: false,
      displayType: "tree", // list/tree
      visible: false,
      dropMenuValue: "",
      dropMenuObj: {},
      dropMenuData: [],
      expandedKeys: [],
      checkedKeys: [],
      datas: [],
      activeKey: (props.tabs && props.tabs[0].key) || "1"
    };
    [
      "onInputChangeHandler",
      "onInputClick",
      "handleOk",
      "handleClear",
      "handleCancel",
      "changeTab",
      "onDropMenuSelect",
      "onSearchChange"
    ].forEach(method => {
      this[method] = this[method].bind(this);
    });
  }
  componentDidMount() {
    // 默认显示数据
    if (!isEmpty(this.props.replaceDatas)) {
      this.replaceSearchValues(this.props.replaceDatas);
    }
    this.props.initFunc && this.props.initFunc(this);
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value && isEmpty(nextProps.value)) {
      this.handleClear();
    }
    if (!isEqual(this.props.replaceDatas, nextProps.replaceDatas)) {
      this.replaceSearchValues(nextProps.replaceDatas);
    }
    if ("valueObj" in nextProps && nextProps.valueObj) {
      this.replaceSearchValues(nextProps.valueObj || []);
    }
  }
  formatDropMenuDatas(data) {
    const dropMenuValue =
      this.state.dropMenuValue ||
      WeaTools.getSelectDefaultValue(data.options) ||
      data.options[0].key;
    const dropMenuData = [];
    let dropMenuObj = data.options[0];
    data.options &&
      data.options.forEach(o => {
        o.companyid = o.key;
        o.name = o.name || o.showname;
        if (data.selected == o.key) {
          dropMenuObj = o;
        }
        dropMenuData.push(o);
      });
    this.setState({
      dropMenuValue,
      dropMenuData,
      dropMenuObj
    });
  }
  getData(searched = false, otherParams = {}) {
    this.setState({ loading: true });
    const res = util.getUrl(this, searched);
    WeaTools.callApi(res.url, "GET", { ...res.params, ...otherParams })
      .then(data => {
        if (data.type == 3) {
          // 树
          this.formatDropMenuDatas(data.selectDatas);
          if (!isEmpty(data.datas)) {
            this.setState({
              displayType: "tree",
              datas: data.datas,
              loadAll: data.isLoadAll,
              loading: false
            });
          }
        }
      })
      .then(() => {});
  }
  changeTab(v) {
    this.setState(
      {
        activeKey: v,
        checkedKeys: [],
        checkedDatas: [],
        expandedKeys: [],
        inputValue: ""
      },
      () => {
        this.getData();
      }
    );
  }
  onDropMenuSelect(v) {
    const menuObj =
      this.state.dropMenuData.find(data => data.key === v.key) || {};
    this.setState(
      {
        dropMenuValue: v.key,
        checkedKeys: [],
        checkedDatas: [],
        expandedKeys: [],
        inputValue: "",
        dropMenuObj: menuObj
      },
      () => {
        this.getData(false, { key: v.key });
      }
    );
  }
  onSearchChange(v) {
    const params = [];
    params[this.props.quickSearchName] = v;
    params.key = this.state.dropMenuValue;
    this.getData(true, params); // 搜索获取数据
    this.setState({
      checkedKeys: [],
      checkedDatas: [],
      expandedKeys: [],
      inputValue: v
    });
  }
  closeModal() {
    this.setState({ visible: false });
  }
  openModal() {
    this.onCustomClick();
  }
  showModal() {
    this.setState({ visible: true });
    this.props.onOpen && this.props.onOpen();
  }
  onCustomClick = e => {
    e && e.preventDefault();
    const { memorise } = this.props;
    if (memorise) {
      const { searchKeys, selectedData } = this.state;
      this.onInputClick(searchKeys, selectedData);
    } else {
      this.onInputClick();
    }
  };
  onInputClick() {
    this.setState(initialState);
    this.showModal();
    this.getData();
  }
  handleOk() {
    const { checkedDatas } = this.state;
    const values = [];
    const selectedData = {};
    !isEmpty(checkedDatas) &&
      checkedDatas.forEach(d => {
        values.push(d.id);
        selectedData[d.id] = d;
      });
    this.setState({
      visible: false,
      searchKeys: values,
      selectedData
    });
    this.props.onClose && this.props.onClose();
    this.throwCurrentState(values.join(this.delimiter), checkedDatas);
  }
  handleCancel() {
    this.setState({
      visible: false
    });
    this.props.onClose && this.props.onClose();
  }
  handleClear() {
    this.setState({
      checkedDatas: [],
      visible: false,
      selectedData: {},
      searchKeys: []
    });
    this.refs.associativeInput.clear();
    this.throwCurrentState("");
    this.props.onClose && this.props.onClose();
  }
  replaceSearchValues(datas = []) {
    const searchKeys = [];
    const selectedData = {};
    datas.forEach(item => {
      if (item) {
        searchKeys.push(item.id);
        selectedData[item.id] = item;
      }
    });
    this.setState({ searchKeys, selectedData });
    const ids = uniq(searchKeys).join(this.delimiter);
    this.setState({ hiddenIds: ids });
  }
  onInputChangeHandler(values, datas) {
    this.setState({ searchKeys: values, selectedData: datas });
    const throwDatas = [];
    if (!isEmpty(values)) {
      values.forEach(v => {
        throwDatas.push(datas[v]);
      });
    }
    this.throwCurrentState(values.join(this.delimiter), throwDatas);
  }
  count(datas = [], rNum = false) {
    let count = 0;
    const ids = [];
    datas.forEach(item => {
      ids.push(item.id);
    });
    count += uniq(ids).length;
    if (rNum) return count;
    return count > 0 ? `(${count})` : "";
  }
  throwCurrentState(ids, datas = []) {
    this.setState({ hiddenIds: ids });
    const names = [];
    datas.map(d => {
      names.push(d.name);
      d.dropMenuValue = this.state.dropMenuValue;
      d.dropMenuUrl = this.state.dropMenuObj.url;
      d.activeKey = this.state.activeKey;
      return d;
    });
    this.props.onChange &&
      this.props.onChange(ids, names.join(this.delimiter), datas);
  }
  getFooter() {
    const { props, state } = this;
    const footer = props.buttons || [
      <Button
        key="submit"
        type="primary"
        onClick={this.handleOk}
        disabled={this.count(state.checkedDatas, true) == 0}
      >
        {getLabel("385565", "确 定")}
        {this.count(state.checkedDatas)}
      </Button>,
      <Button key="clear" type="ghost" onClick={this.handleClear}>
        {getLabel("385566", "清 除")}
      </Button>,
      <Button key="back" type="ghost" onClick={this.handleCancel}>
        {getLabel("385567", "取 消")}
      </Button>
    ];
    return footer;
  }
  getTabs() {
    const { props, state } = this;
    const datas = [];
    props.tabs &&
      props.tabs.forEach(t => {
        t.title = t.title || t.name;
        datas.push(t);
      });
    return (
      <WeaTab
        datas={datas}
        searchsBaseValue={state.inputValue}
        selectedKey={state.activeKey}
        keyParam="key"
        onChange={this.changeTab}
        onSearchChange={this.onSearchChange}
      />
    );
  }
  render() {
    const { props, state } = this;
    const inputArr = (
      <WeaAssociativeSearchMult
        {...this.props}
        ref="associativeInput"
        style={props.inputStyle}
        datas={state.selectedData}
        selectedValues={state.searchKeys}
        type={props.type}
        clickCallback={this.onInputClick}
        onChange={this.onInputChangeHandler}
      />
    );
    const cHeight = props.contentHeight - 46;
    let dom = inputArr;
    if (props.customized) {
      dom = (
        <div className="cursor-pointer" onClick={this.onCustomClick}>
          {this.props.children}
        </div>
      );
    }
    return (
      <div>
        {dom}
        <WeaDialog
          {...this.props}
          height={579}
          style={props.modalStyle}
          title={props.title}
          visible={state.visible}
          buttons={this.getFooter()}
          maskClosable={false}
          hasScroll={false}
          onCancel={this.handleCancel}
        >
          {this.getTabs()}
          <Spin spinning={state.loading}>
            <WeaDropMenu
              value={state.dropMenuValue}
              dropMenu={state.dropMenuData}
              onSelect={this.onDropMenuSelect}
            />
            {state.displayType == "tree" && (
              <WeaNewScroll height={cHeight}>
                <WeaTree
                  checkable
                  showCheckStrictly
                  datas={state.datas}
                  checkStrictlyTitle={props.checkStrictlyTitle}
                  loadAll={state.loadAll}
                  onCheck={(checkedKeys, nodeids, checkedDatas) =>
                    this.setState({
                      checkedKeys: !isEmpty(nodeids) ? nodeids : checkedKeys,
                      checkedDatas
                    })
                  }
                  checkedKeys={state.checkedKeys}
                  expandedKeys={state.expandedKeys}
                  onExpand={(expandedKeys, nodeids) =>
                    this.setState({
                      expandedKeys: !isEmpty(nodeids) ? nodeids : expandedKeys
                    })
                  }
                />
              </WeaNewScroll>
            )}
          </Spin>
        </WeaDialog>
      </div>
    );
  }
}

export default main;



// WEBPACK FOOTER //
// ./ecology9/wea-browser/coms/WeaSystempage.js